export default __webpack_public_path__ + "static/media/pakrap-2.9fd06d26.mp3";